import { defineStore } from 'pinia'
import moment from 'moment'
import repositoryFactory from '@/factories/repository-factory'
import WeatherWarningHistory2Repository from '@/repositories/weather-warning-history2-repository'
import WeatherWarningHistory2 from '@/models/WeatherWarningHistory2'
import { rangeToISO } from '@/lib/formatter'

const storeKey = 'weather-warning-history'

type Store = {
  weatherWarningHistory: WeatherWarningHistory2
}

export const useWeatherWarningHistoryStore = defineStore(storeKey, {
  state: () =>
    ({
      weatherWarningHistory: {} as WeatherWarningHistory2,
    } as Store),

  actions: {
    async fetch(areaCode: string, from: moment.Moment = moment().add(-1, 'month'), to: moment.Moment = moment()) {
      const repoKey = 'weatherWarningHistory2'
      const repository = (await repositoryFactory.create()).get(repoKey) as WeatherWarningHistory2Repository
      const startTime = from.format()
      const endTime = to.format()
      const range = { startTime, endTime }
      const params = {
        areaCode,
        range: rangeToISO(range as Range),
      }
      this.weatherWarningHistory = await repository.get(params)
    },
  },
})
